
console.log('custom-cart-drawer.js loaded');

document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(form);

try {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) throw new Error('Add to cart failed');

  const res = await fetch('/cart?view=drawer-dynamic');
  const html = await res.text();

  const tmp = document.createElement('div'); // ✅ this was missing
  tmp.innerHTML = html;

  const newDrawer = tmp.querySelector('cart-drawer');
  const currentDrawer = document.querySelector('cart-drawer');

  if (newDrawer && currentDrawer) {
    currentDrawer.replaceWith(newDrawer);

    setTimeout(() => {
      newDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }, 30);
  } else {
    console.warn('Cart drawer structure missing. Skipping update.');
  }
} catch (err) {
  console.error('Cart drawer error:', err);
}

  });
});

